// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"appointments__AppointmentDialog__errorWrapper"};